import { Environment } from './environment.interface';

/**
 * QA Environment Configuration - Entra ID
 */
export const environment: Environment = {
  production: false,
  
  msalConfig: {
    auth: {
      clientId: 'cbb01810-12ce-418e-b034-af84d4127fbc', // ARFD QA Consumer
      authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
    },
    redirectUri: '/redirect',
    postLogoutRedirectUri: '/',
    loginFailedUri: '/login-failed'
  },
  
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  
  myApiConfig: {
    scopes: ['api://e5f5db5c-8f96-47bd-a9ec-ce54f1dcc6aa/webapp'], // ARFD QA Provider
    uri: 'https://api-qat.mss.ford.com/api_arfd/api/v1/'
  },
  
  api: 'https://api-qat.mss.ford.com/api_arfd/api/v1/',
  logoutUrl: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0/oauth2/v2.0/logout'
};